// Vendor libraries
import { EventEmitter } from '@angular/core';
// Components
import { BaseAutocompleteComponent } from 'SearchApp/ts/features/base-autocomplete/components/base-autocomplete.component';
import * as i0 from "@angular/core";
import * as i1 from "../base-autocomplete/components/base-autocomplete.component";
/**
 *
 * Add Button Autocomplete Component
 *
 * Output Properties:
 *   submitHandler: EventEmitter that emits the selected AutocompleteResult
 */
export class AddButtonAutocompleteComponent {
    constructor() {
        this.placeholder = 'Search';
        this.isInvalid = false;
        this.isDisabled = false;
        this.searchableSecurityIds = [];
        this.defaultOnly = false;
        this.submitHandler = new EventEmitter();
    }
    focus() {
        if (this.baseAutocompleter) {
            this.baseAutocompleter.focus();
        }
    }
}
AddButtonAutocompleteComponent.ɵfac = function AddButtonAutocompleteComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AddButtonAutocompleteComponent)(); };
AddButtonAutocompleteComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AddButtonAutocompleteComponent, selectors: [["ycn-add-button-autocomplete"]], viewQuery: function AddButtonAutocompleteComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(BaseAutocompleteComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.baseAutocompleter = _t.first);
    } }, inputs: { appendToBody: "appendToBody", searchType: "searchType", placeholder: "placeholder", isInvalid: "isInvalid", isDisabled: "isDisabled", searchableSecurityIds: "searchableSecurityIds", defaultOnly: "defaultOnly" }, outputs: { submitHandler: "submitHandler" }, standalone: false, decls: 1, vars: 8, consts: [[1, "input-group", 3, "submitHandler", "placeholder", "appendToBody", "buttonType", "searchType", "isInvalid", "isDisabled", "searchableSecurityIds", "defaultOnly"]], template: function AddButtonAutocompleteComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-base-autocomplete", 0);
        i0.ɵɵlistener("submitHandler", function AddButtonAutocompleteComponent_Template_ycn_base_autocomplete_submitHandler_0_listener($event) { return ctx.submitHandler.emit($event); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("placeholder", ctx.placeholder)("appendToBody", ctx.appendToBody)("buttonType", "add")("searchType", ctx.searchType)("isInvalid", ctx.isInvalid)("isDisabled", ctx.isDisabled)("searchableSecurityIds", ctx.searchableSecurityIds)("defaultOnly", ctx.defaultOnly);
    } }, dependencies: [i1.BaseAutocompleteComponent], encapsulation: 2 });
